
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 法人管理
              <div class="card-header-actions">
              </div>
            </CCardHeader>
            <CCardBody>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="organizations"
                :fields="fields"
                itemsPerPage="30"
                pagination
              >
                <template #title="{item}">
                  <td>
                    <CLink :href="'/organizations/' + item.id" > {{ item.title }}</CLink>
                  </td>
                </template>
                <template #industry_id="{item}">
                  <td>{{ industries[item.industry_id] }}</td>
                </template>
                <template #state="{item}">
                  <td><CBadge :color="stateColor(item.state)">{{ stateDic[item.state] }}</CBadge></td>
                </template>
                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #updated_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm"><a :href='"jobs/" + item.id + "/form"'>編集</a></CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>


              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteJob()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
//TODO: ぱんくず

import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {
    Paginate
  },
  data() {
    return {
      organizations: [],
      fields: [
        { key: 'id', label: ""},
        { key: 'jobs', label: "掲載求人数"},
        { key: 'name', label: "法人名"},
        { key: 'industry', label: "業種"},
        { key: 'description', label: "説明"},
        { key: 'zip', label: "郵便番号"},
        { key: 'phone', label: "電話番号"},
        { key: 'created_at', label: "作成日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      industries: {},
      mode: "",
      username: '',
      password: '',
      itemIndex: 0,
      record_id: this.$route.params.id,
      meta: {},
      record: {
        name: "",
        description: ""
      },
      stateDic: {
        'public': '公開中',
        'private': '非公開',
        'draft': '下書き'
      },
    }
  },
  validations: {
    record: {
      name: {required},
      description: {required}
    }
  },
  methods: {
    stateColor: function(e) {
      if(e == "public") {
        return 'success'
      } else if(e == "private") {
        return 'warning'
      } else {
        return 'dark'
      }
    },
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    showDeleteModal: function(p, i) {
      this.deleteModal = true
      this.record = p
      this.itemIndex = i
    },
    deleteJob: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/jobs/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.jobs.splice(this.itemIndex, 1)
        }).catch(error => {
          console.log(error)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/industries?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            console.log(response.data.industries)
            this.items = response.data.industries
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
      return moment(d).format("YYYY/MM/DD HH:mm")
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.record.id)
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/organizations", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.organizations = response.data.organizations
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

